import Button from "@/components/shared/Button";
import ServiceCard from "@/components/shared/ServiceCard";
import Title from "@/components/shared/Title";
import { useSiteData } from "@/context/SiteDataContext";
import usePageMetadata from "@/lib/usePageMetadata";
import React from "react";
import { GoArrowUpRight } from "react-icons/go";
import { Link } from "react-router";

function Services() {
  const { siteData, loading } = useSiteData();
  const services = siteData?.services || [];

  usePageMetadata(
    "Services | BioStat",
    "Explore the services we offer to support your medical research journey.",
  );

  if (loading) return <p className="py-10 text-center">Loading services...</p>;

  return (
    <section className="px-4 py-12 text-center md:px-12 xl:px-16">
      <div className="flex flex-col items-center">
        <Title title="Our Services" className="mb-6 xl:mb-12" />
      </div>

      <h2 className="text-dark mb-6 text-2xl font-semibold md:text-4xl xl:mb-12">
        Explore the services we offer to support your{" "}
        <br className="hidden lg:block" />
        medical research journey.
      </h2>

      <div className="grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {services.map((service, index) => (
          <ServiceCard key={index} service={service} /> // Using the ServiceCard component
        ))}
      </div>
    </section>
  );
}

export default Services;
